import React from "react";
import { Link } from "react-router-dom";
import "../assets/styles/ContactPage.css";

const ContactPage = () => (
  <div className="page-shell internal-page">
    <section className="page-hero">
      <p className="section-kicker">Contact</p>
      <h1>Connect with the campaign.</h1>
      <p>
        Reach out for campaign questions, event information, volunteer opportunities, or general
        support.
      </p>
    </section>

    <section className="contact-layout">
      <div className="contact-card">
        <p className="section-kicker">Campaign office</p>
        <h2>Direct contact information</h2>
        <a href="mailto:brian@brianforflorida.com" className="contact-link">
          brian@brianforflorida.com
        </a>
        <a href="tel:3212094645" className="contact-link">
          (321) 209-4645
        </a>
        <p className="contact-note">
          The fastest way to connect is by email. Include your name, phone number, and the reason for
          your message.
        </p>
      </div>

      <form
        className="styled-form"
        action="mailto:brian@brianforflorida.com"
        method="post"
        encType="text/plain"
      >
        <h2>Send a message</h2>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input type="text" id="name" name="name" placeholder="Enter your name" />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input type="email" id="email" name="email" placeholder="Enter your email" />
        </div>

        <div className="form-group">
          <label htmlFor="phone">Phone</label>
          <input type="tel" id="phone" name="phone" placeholder="Enter your phone number" />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea id="message" name="message" placeholder="Enter your message" />
        </div>

        <div className="sms-consent">
          <label htmlFor="sms-consent">
            <input
              type="checkbox"
              id="sms-consent"
              name="smsConsent"
              value="I agree to accept communications as outlined on this page"
            />
            <span>I agree to accept communications as outlined on this page</span>
          </label>
          <p>
            You agree to receive informational messages or donation request messages from the Brian
            Hodgers Campaign. Message frequency varies. Message and data rates may apply. For help,
            email us at <a href="mailto:brian@brianforflorida.com">brian@brianforflorida.com</a>. You
            can opt out at any time by replying STOP. For more, see our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
            <Link to="/terms-and-conditions">Terms & Conditions</Link>.
          </p>
        </div>

        <button type="submit" className="btn-submit">
          Email the campaign
        </button>
      </form>
    </section>
  </div>
);

export default ContactPage;
